import Vue from 'vue';
import VueRouter from 'vue-router';
import Buefy from 'buefy';
import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Buefy);

import router from './router/router';
import store from './store/store';

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
